import React, { useState } from 'react'
import { useFormik } from 'formik';
import toast from 'react-hot-toast';
import { useAdminContext } from '../../../context/adminContext';
import { updateJobApplicationApi } from '../../../utils/ApiEndpointFunctions';
import { jobApplicationInitialValues, jobApplicationValidationSchema } from '../../common/Validation';
import CommonTable from '../../common/Table/CommonTable';
import JobApplicationModal from '../../common/Modal/JobApplicationModal';
import { S3_URL } from '../../../utils/BaseUrl';

function JobApplicationTable(props) {
  const { setConfirmStatus, loader, data, getApplicationList, debouncedOnChange, deleteModalId } = props;
  const { limit } = useAdminContext();
  const [submitLoader, setSubmitLoader] = useState(false)

  const JobApplicationModalId = "JobApplicationModalId"
  const confirmApproveOrReject = (status, id) => {
    setConfirmStatus({ status, id})
  }

  const handleSubmit = async (values) => {
    try {
      // console.log("inside if block")
      setSubmitLoader(true)
      // console.log("valllllllllll",values)
      const payload= {
        id:formik?.values?.id , 
        status: formik.values?.status
      }
      const res = await updateJobApplicationApi(payload)
    // const res = null
      if (res.status === 200) {
        // console.log(res.data)
        toast.success(res.data?.message);
        getApplicationList();
        document.getElementById(JobApplicationModalId).click();
        formik.resetForm();
      }
    } catch (error) {
      console.log(error)
      toast.error(error.response?.data?.message ? error.response.data.message : "Something went wrong");
    }
    setSubmitLoader(false)

  }

  const formik = useFormik({
    initialValues: jobApplicationInitialValues,
    onSubmit: handleSubmit,
    validationSchema: jobApplicationValidationSchema
  })

//   const adminLabels = (str) => {
//     switch(str) {
//       case "admin1": return 'Admin 1 - Access Partner without Rates';
//       case "admin2": return 'Admin 2 - Access Partner with Rates';
//       case "superAdmin": return "Super Admin";
//       case "webAdmin": return "Web"
//       default: return "Country Admin";
//     }
//   }

  const headerData = [
    { name: "S.No", key: "index", className: "col" },
    { name: "Name", key: "name", className: "col" },
    { name: "Email", key: "email", className: "col" },
    { name: "Phone", key: "phone", className: "col" },
    { name: "Resume", key: "resume", className: "col" },
    { name: "Job", key: "job", className: "col" },
    {name:"Status", key:"status", className: 'col'},
    { name: "Action", key: "action", className: "col" },
  ];

  const formatFormikData = (item)=>{
    return {
      id:item?.id,
      type:"update",
      firstName: item.firstName,
      lastName: item.lastName,
      email: item.email,
      phone: item.phone,
      resume: item.resume,
      job: item.job,
      status: item.status
    }
  }


  const tableData = data?.map((item, index) => ({
    index: index + 1,
    name: item.firstName+" "+item.lastName,
    email: item.email,
    phone: item.phone,
    resume: (
      <a href={`${S3_URL}/${(item.resume)}` } target='_blank' >{(item.resume).split('/')[1]}</a>
    ),
    job: item.job,
    status: item.status,
    action: (
      <div className="dropdown">
        <button
          className=" border-0 bg-white"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-three-dots-vertical"
            viewBox="0 0 16 16"
          >
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
          </svg>
        </button>
        <ul className="dropdown-menu" style={{ zIndex: "1000" }}>
        {item?.isActive &&  <li
            data-bs-toggle="modal"
            data-bs-target={`#${JobApplicationModalId}`}
            onClick={() => formik.setValues(formatFormikData(item))}
          >
            <a className="dropdown-item" href="#">
              Edit
            </a>
          </li>}
          {/* <li
            data-bs-toggle="modal"
            data-bs-target={`#${deleteModalId}`}
            onClick={() => confirmApproveOrReject(!item?.isActive, item.id)}
          >
            <a className="dropdown-item" href="#">
           { !item?.isActive ? "Enable" : "Disable"}
            </a>
          </li> */}
        </ul>
      </div>
    ),
  }));

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap align-items-center mt-3 mt-lg-0">
        <div className="ms-auto" style={{ display: "-webkit-inline-box" }}>
          <div className="position-relative my-3">
            <div className="d-flex gap-2">
              <input
                className="form-search me-3"
                type="search"
                name="searchField"
                placeholder="Search by Name/ Email"
                onChange={debouncedOnChange}
              />
              {/* <button
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target={`#${AddAdminModalId}`}
                onClick={() => formik.resetForm()}
              >
                Add
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <CommonTable headers={headerData} data={tableData} loading={loader} />
      <JobApplicationModal  formik={formik} modalId={JobApplicationModalId} loader={submitLoader} />
    </>
  );
}

export default JobApplicationTable